import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';

import {
  sortVideoDownloadLinksByResolution,
  videoIsProcessed,
} from '../../../../util/video';
import Button from '../../../global/Button';
import { VideoDownloadLink } from '../../../../graphql/queries/video';
import Spinner from '../../../global/Spinner';
import Alert from '../../../global/Alert';

const propTypes = {
  video: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const VideoDownload = ({ video }) => {
  const isVideoProcessed = videoIsProcessed(video);
  const { data: { videoDownloadLinks } = {}, loading } = useQuery(
    VideoDownloadLink,
    {
      variables: {
        id: video.id,
      },
      skip: !video || !isVideoProcessed,
    },
  );

  const sortedVideoDownloadLinks = sortVideoDownloadLinksByResolution(
    videoDownloadLinks,
  );

  if (loading) {
    return (
      <div className="p-5 d-flex">
        <Spinner className="m-auto" />
      </div>
    );
  }

  return (
    <>
      <p className="text-dark">
        Please select how you want to download this video:
      </p>
      {isVideoProcessed ? (
        <div className="video-download-grid">
          {sortedVideoDownloadLinks.map(downloadLink => (
            <Button
              btnStyle="reset"
              key={downloadLink.url}
              href={downloadLink.url}
              className="video-download-link-btn"
              target="_blank"
            >
              <span className="text-xs">
                {downloadLink.quality.toUpperCase()}
              </span>
              <span className="d-block">
                {downloadLink.width}&times;{downloadLink.height}
              </span>
              <span className="text-xs text-faded">
                {downloadLink.filesize_short}
              </span>
            </Button>
          ))}
        </div>
      ) : (
        <Alert type="info">
          This video is not processed yet. Once the video processing is
          complete, you will be able to download this video in multiple
          resolutions.
        </Alert>
      )}
    </>
  );
};

VideoDownload.propTypes = propTypes;

export default VideoDownload;
